import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const WorkersPageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
